export default class NodeDefinitionClassCommon {
	/**
	 * @param {any} common
	 */
	constructor(common) {
		this.card_from = common?.card_from ?? 1;
		this.card_to = common?.card_to ?? 1;
		this.data = common?.data;
		this.dico_id = common?.dico_id;
		this.internal = !!common?.internal;
		this.lock = Number.parseInt(common?.lock ?? 0);
		this.type = common?.link ?? 'link';
	}
}
